<template>
  <svg
    version="1.1"
    :id="iconName"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 17 22"
    fill="none"
    style="enable-background:new 0 0 17 22;"
    :class="iconName"
    xml:space="preserve"
    :width="width"
    :height="height"
  >
    <title :id="iconName" lang="en">{{ iconName }} icon</title>
    <g id="icon_bell">
      <path
        id="Ellipse 1"
        d="M8.44312 1C4.64617 1 1.56813 3.91014 1.56813 7.49999V14.6071L1.00008 17.25H15.8181L15.3181 14.6071V7.49999C15.3181 3.91014 12.2401 1 8.44312 1Z"
        stroke-linejoin="round"
      />
      <path id="Vector 21" d="M3.31836 15H11.3184" stroke-linecap="round" />
      <path
        id="Ellipse 2"
        d="M10.3184 19C10.3184 20.1046 9.42293 21 8.31836 21C7.21379 21 6.31836 20.1046 6.31836 19"
        stroke-linecap="round"
      />
    </g>
  </svg>
</template>
<style scoped>
.icon-bell {
  stroke: currentColor;
  height: 24px;
  width: 24px;
  border-radius: initial;
  display: block;
}
</style>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "icon-bell"
    },
    width: {
      type: [Number, String],
      default: 12
    },
    height: {
      type: [Number, String],
      default: 12
    },
    iconColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>